import URLSearchParams from '@ungap/url-search-params';

export function parseQueryString(s = location.search) {
  return new URLSearchParams(s);
}

export function updateQueryStringParam(key, value) {
  const params = new URLSearchParams(location.search);
  params.set(key, value);
  window.history.replaceState({}, '', `${location.pathname}?${params}`);
}
